// extracted by mini-css-extract-plugin
var _1 = "ExtensionApp-module__container--LlnU0";
export { _1 as "container" }
